export interface ApiTokenSummary {
  id: string;
  name: string;
  created: string;
  expires: string;
  lastUsedUtc?: string | null;
  partialToken: string;
}

export interface Resource {
  resourceId: string;
  access: number;  
}

export interface ApiToken {
  id: string;
  name: string;
  created: string;
  expires: string;
  lastUsedUtc?: string | null;
  partialToken: string;
  resources: Array<Resource>;
  projects: SpecificProjectPermission[];
}

export interface SpecificProjectPermission {
  id: number;
  view: boolean;
  update: boolean;
}

export interface CreateApiTokenRequest {
  name: string;
  expires: string;
  timezone: string;
  resources: string[];
  projects: SpecificProjectPermission[];
}

export interface CreateApiTokenResponse {
  success: boolean;
  token?: string; 
  apiToken?: ApiTokenSummary; 
  errors?: any;
}

export interface UpdateApiTokenRequest {
  id: string;
  name: string;
  expires: string;
  timezone: string;
  resources: string[];
  projects: SpecificProjectPermission[];
}

export interface UpdateApiTokenResponse {  
  success: boolean;
  token?: string; 
  apiToken?: ApiTokenSummary; 
  errors?: any;
}

export interface RenewApiTokenRequest {
  originalApiTokenId: string;
  name: string;
  newExpiryDate: string;  
}

export interface RenewApiTokenResponse {  
  success: boolean;
  token?: string; 
  apiToken?: ApiTokenSummary; 
  errors?: any;
}

export enum FormMode {
  Add = 1,
  Update,
  Renew
}